import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Booth } from './booth.model';
import { BoothService } from './booth.service';

@Component({
    selector: 'jhi-booth-detail',
    templateUrl: './booth-detail.component.html'
})
export class BoothDetailComponent implements OnInit, OnDestroy {

    booth: Booth;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private boothService: BoothService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInBooths();
    }

    load(id) {
        this.boothService.find(id).subscribe((booth) => {
            this.booth = booth;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInBooths() {
        this.eventSubscriber = this.eventManager.subscribe('boothListModification', (response) => this.load(this.booth.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/booth/booth-detail.component.ts